import { useMutation } from '@apollo/client';
import { CREATE_REPLY } from '../../graphql/reply-mutations';

export default function useAddReply() {
    const [addReply, { loading }] = useMutation(CREATE_REPLY);
    return { addReply, loading };
}
